module.exports = __webpack_public_path__ + "img/6.da08f903.jpg";